import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TraderInterface } from '../data';
import { TraderProvider } from '../providers/trader.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetTradersUseCase implements UseCase<Observable<Transaction<TraderInterface[]>>> {
    constructor(private traderProvider: TraderProvider) {}

    bind(): Observable<Transaction<TraderInterface[]>> {
        return this.traderProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (traders) => Transaction.success(cloneDeep(traders)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
